import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AccountHelper from 'Workspace/helpers/AccountHelper';
import StudentSummaryContainer from './StudentSummaryContainer';
import { ActiveStudentWrapper } from './styles';
import Paginator from './Paginator.js';

const ActiveStudent = ({ students, activeStudent, variables, maxScore, attemptId }) => {
  const { cohortId, deploymentId, componentId, interactiveId } = variables;
  const props = { ...variables };
  const routeToManualGradeReview = `/classes/${cohortId}/review/${deploymentId}/${interactiveId}/${componentId}`;

  const sortedStudentList = useMemo(
    () => Object.values(students).sort(AccountHelper.sortListByFamilyName),
    [students],
  );

  return (
    <ActiveStudentWrapper>
      <StudentSummaryContainer
        activeStudent={activeStudent}
        list={sortedStudentList}
        constantRoute={routeToManualGradeReview}
        maxScore={maxScore}
        attemptId={attemptId}
        {...props}
      />
      <Paginator list={sortedStudentList} value={activeStudent} constantRoute={routeToManualGradeReview} />
    </ActiveStudentWrapper>
  );
};

ActiveStudent.propTypes = {
  students: PropTypes.object.isRequired,
  activeStudent: PropTypes.object,
  variables: PropTypes.object,
  maxScore: PropTypes.number,
  attemptId: PropTypes.string,
};

export default ActiveStudent;
